export default __webpack_public_path__ + "static/media/bubble_1_right.acddc765.png";